import { Component, OnInit, Input, Injectable } from '@angular/core';
import { dataModel } from '../../models/data.model';

@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass'],
})

export class HeaderComponent implements OnInit {
  @Input() data: dataModel;
  user = false;
  colapseToggle = false;
  innerWidth: any;
  constructor() { }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
  }

  toggle() {
    if (!this.colapseToggle) {
      this.colapseToggle = true;
    } else {
      this.colapseToggle = false;
    }
  }

}
